import keyMirror from '../../../utils/keyMirror';

export default keyMirror(['SET_ROUTES', 'CHANGE_ROUTE']);
